<template>
    <b-modal
        id="school-add-user-modal"
        :title="$t('school.new_user')"
        :ok-title="$t('common.save')"
        @ok="save($event)"
        :cancel-title="$t('common.cancel')"
        cancel-variant="outline-primary"
        modal-class="apprentice-default-modal"
        @show="show">
        <b-form-group
            :label="$t('common.first_name')"
            label-for="name">
            <b-alert
                v-if="nameError"
                show
                variant="danger"
                >{{ $t('school.first_name_mandatory') }}</b-alert
            >

            <b-form-input
                id="name"
                v-model="name"
                required
                :placeholder="$t('common.first_name')"></b-form-input>
        </b-form-group>

        <b-form-group
            :label="$t('common.infix')"
            label-for="preposition">
            <b-form-input
                id="preposition"
                v-model="preposition"
                :placeholder="$t('common.infix')"></b-form-input>
        </b-form-group>

        <b-form-group
            :label="$t('common.last_name')"
            label-for="surname">
            <b-alert
                v-if="surnameError"
                show
                variant="danger"
                >{{ $t('validation.last_name_mandatory') }}</b-alert
            >

            <b-form-input
                id="surname"
                v-model="surname"
                required
                :placeholder="$t('common.last_name')"></b-form-input>
        </b-form-group>

        <b-form-group
            label="E-mail:"
            label-for="email">
            <b-alert
                v-if="emailDuplicateError"
                show
                variant="danger">
                {{ $t('school.choose_an_other_email_address') }}
            </b-alert>

            <b-form-input
                id="email"
                v-model="email"
                type="email"
                required
                placeholder="E-mail"></b-form-input>
        </b-form-group>

        <b-form-group
            :label="$t('school.role')"
            label-for="role">
            <b-alert
                v-if="roleError"
                show
                variant="danger"
                >{{ $t('school.role_mandatory') }}</b-alert
            >

            <design-2021-apprentice-multiselect-component
                id="school-account-add-user-type"
                v-model="selectedRole"
                label="name"
                :options="options"
                :show-labels="false"
                :multiple-select="false"></design-2021-apprentice-multiselect-component>
        </b-form-group>

        <b-form-group
            :label="$t('common.username')"
            label-for="username">
            <b-alert
                v-if="usernameError"
                show
                variant="danger"
                >{{ $t('school.accounts.username_mandatory') }}</b-alert
            >

            <b-alert
                v-if="usernameDuplicateError"
                show
                variant="danger">
                {{ $t('school.choose_an_other_username') }}
            </b-alert>

            <b-form-input
                id="username"
                v-model="username"
                required
                :placeholder="$t('common.username')"></b-form-input>
        </b-form-group>

        <b-form-group
            :label="$t('common.password')"
            label-for="password">
            <b-alert
                v-if="passwordError"
                show
                variant="danger"
                >{{ $t('school.password_mandatory') }}</b-alert
            >

            <b-form-input
                id="password"
                v-model="password"
                type="password"
                required
                autocomplete="new-password"
                :placeholder="$t('common.password')"></b-form-input>
        </b-form-group>
    </b-modal>
</template>

<script>
import { ords } from '../../../app';

export default {
    name: 'design-2021-school-accounts-index-add-user-modal-component',
    data() {
        return {
            name: '',
            preposition: '',
            surname: '',
            email: '',
            username: '',
            password: '',
            selectedRole: null,
            options: [
                { name: this.$t('school.student'), value: 'student' },
                { name: this.$t('school.teacher'), value: 'teacher' },
            ],
            passwordError: false,
            usernameError: false,
            roleError: false,
            surnameError: false,
            nameError: false,
            usernameDuplicateError: false,
            emailDuplicateError: false,
        };
    },
    methods: {
        save(event) {
            this.nameError = this.name === '';
            this.passwordError = this.password === '';
            this.usernameError = this.username === '';
            this.roleError = this.selectedRole === null;
            this.surnameError = this.surname === '';

            event.preventDefault();

            if (this.nameError || this.passwordError || this.usernameError || this.roleError || this.surnameError) {
                event.preventDefault();
            } else {
                let data = {
                    name: this.name,
                    preposition: this.preposition,
                    surname: this.surname,
                    email: this.email,
                    role: this.selectedRole.value,
                    username: this.username,
                    password: this.password,
                };

                this.alert.saving();

                this.axios.post(this.routes.schoolAccountAdd(), data).then(
                    (response) => {
                        ords.use('user').add(response.data);

                        this.$emit('update-table');

                        this.$bvModal.hide('school-add-user-modal');

                        this.alert.success();
                    },
                    (error) => {
                        if (error.response.data.errors.email || error.response.data.errors.username) {
                            if (error.response.data.errors.email) {
                                this.emailDuplicateError = true;
                            } else {
                                this.emailDuplicateError = false;
                            }

                            if (error.response.data.errors.username) {
                                this.usernameDuplicateError = true;
                            } else {
                                this.usernameDuplicateError = false;
                            }

                            this.alert.close();
                        } else {
                            this.alert.ajaxError(error);
                        }
                    },
                );
            }
        },

        show() {
            this.name = '';
            this.preposition = '';
            this.surname = '';
            this.email = '';
            this.username = '';
            this.password = '';
            this.selectedRole = null;
            this.passwordError = false;
            this.usernameError = false;
            this.roleError = false;
            this.surnameError = false;
            this.nameError = false;
        },
    },
};
</script>

<style scoped></style>
